import { Component } from '@angular/core';

@Component({
    selector: 'app-maximo-data-integrity-check',
    imports: [],
    templateUrl: './maximo-data-integrity-check.component.html',
    styleUrl: './maximo-data-integrity-check.component.scss'
})
export class MaximoDataIntegrityCheckComponent {

}
